import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";

const PublicRoute = ({ children }) => {
    const { currentUser, loading, userData } = useAuth();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    // Get event information from both location.state and searchParams
    const isEventFromState = location.state?.event === true;
    const eventIdFromState = location.state?.eventId;
    const isEventFromParams = searchParams.get('event') === 'true';
    const eventIdFromParams = searchParams.get('eventId') || searchParams.get('id');

    // Determine final event values
    const isEvent = isEventFromState || isEventFromParams;
    const eventId = eventIdFromState || eventIdFromParams;

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-custom-blue-1"></div>
            </div>
        );
    }

    // If user is not authenticated, redirect to login with event parameters
    if (!currentUser) {
        let loginUrl = "/login";
        if (isEvent) {
            loginUrl += `?event=true`;
            if (eventId) loginUrl += `&eventId=${eventId}`;
        }
        return <Navigate to={loginUrl} state={{ from: location, eventId:eventId,isEvent }} replace />;
    }

    // If authenticated, determine where to redirect based on user role
    if (currentUser && userData) {
        // Check user role and redirect accordingly
        if (userData?.role && ['Administrator', 'Judge', 'Mentor'].includes(userData.role)) {
            // Administrators, Judges, and Mentors go to eventdashboard
            return <Navigate to="/eventdashboard/dashboard" replace />;
        }
    }

    return children;
};

export default PublicRoute;
